// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableBodyRowMenu__Huvtn {
  width: 25px;
  cursor: pointer;
  position: relative;
  text-align: center;
  margin-right: 5px;
  outline: 0;
  box-shadow: none;
}

.tableBodyRowMenuPopover__iFJMg {
  width: 210px;
  position: absolute;
  right: 30px;
  top: 0;
  min-width: 16px;
  min-height: 16px;
  max-height: 300px;
  background: var(--context-menu-surface);
  box-shadow: var(--basic-box-shadow);
  z-index: 10;
}

.tableBodyRowMenuPopoverItem__efBp2 {
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid var(--context-menu-stroke);
  text-decoration: none;
  display: flex;
  align-items: center;
  color: var(--context-menu-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  padding: 0 10px;
  height: 40px;
  gap: 10px;
}
.tableBodyRowMenuPopoverItem__efBp2:last-child {
  border: none;
}
.tableBodyRowMenuPopoverItem__efBp2 svg path {
  fill: var(--buttons-surface);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/components/ActionItemTableMenu/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,mCAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AAzEF;AA2EE;EACE,YAAA;AAzEJ;AA6EI;EACE,4BAAA;AA3EN","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableBodyRowMenu {\n  width: 25px;\n  cursor: pointer;\n  position: relative;\n  text-align: center;\n  margin-right: 5px;\n  outline: 0;\n  box-shadow: none;\n}\n\n.tableBodyRowMenuPopover {\n  width: 210px;\n  position: absolute;\n  right: 30px;\n  top: 0;\n  min-width: 16px;\n  min-height: 16px;\n  max-height: 300px;\n  background: var(--context-menu-surface);\n  box-shadow: var(--basic-box-shadow);\n  z-index: 10;\n}\n\n.tableBodyRowMenuPopoverItem {\n  cursor: pointer;\n  text-align: left;\n  border-bottom: 1px solid var(--context-menu-stroke);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  color: var(--context-menu-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n  padding: 0 10px;\n  height: 40px;\n  gap: 10px;\n\n  &:last-child {\n    border: none;\n  }\n\n  svg {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBodyRowMenu": `tableBodyRowMenu__Huvtn`,
	"tableBodyRowMenuPopover": `tableBodyRowMenuPopover__iFJMg`,
	"tableBodyRowMenuPopoverItem": `tableBodyRowMenuPopoverItem__efBp2`
};
module.exports = ___CSS_LOADER_EXPORT___;
